"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localized_strings_1 = __importDefault(require("localized-strings"));
const types_1 = require("../../types");
const locales = new localized_strings_1.default({
    en: {
        page: 'Page',
        type: {
            [types_1.InvoiceType.Invoice]: 'Invoice no{fiscalId} - ',
            [types_1.InvoiceType.Quote]: 'Quote no{fiscalId} - ',
        },
    },
    fr: {
        page: 'Page',
        type: {
            [types_1.InvoiceType.Invoice]: 'Facture n°{fiscalId} - ',
            [types_1.InvoiceType.Quote]: 'Devis n°{fiscalId} - ',
        },
    },
});
exports.default = locales;
